import {
  createParser,
  parseAsArrayOf,
  parseAsIsoDate,
  parseAsString,
  parseAsStringLiteral,
  type SingleParserBuilder,
} from 'nuqs';

export interface ReportDateRange {
  from?: Date;
  to?: Date;
}

const CANONICAL_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const parseAsReportDate: SingleParserBuilder<Date> = createParser({
  parse: value => {
    if (!CANONICAL_DATE_PATTERN.test(value)) {
      return null;
    }

    const utcDate = parseAsIsoDate.parse(value);
    if (
      utcDate === null ||
      `${utcDate.getUTCFullYear()}-${String(utcDate.getUTCMonth() + 1).padStart(2, '0')}-${String(utcDate.getUTCDate()).padStart(2, '0')}` !==
        value
    ) {
      return null;
    }

    return new Date(
      utcDate.getUTCFullYear(),
      utcDate.getUTCMonth(),
      utcDate.getUTCDate()
    );
  },
  serialize: value =>
    `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`,
  eq: (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate(),
});

export const reportDateRangeParsers = {
  from: parseAsReportDate,
  to: parseAsReportDate,
};

export const REPORT_SORT_DIRECTIONS = ['asc', 'desc'] as const;
export type ReportSortDirection = (typeof REPORT_SORT_DIRECTIONS)[number];
export const parseAsReportSortDirection = parseAsStringLiteral(
  REPORT_SORT_DIRECTIONS
);

export function createReportSortParser<const T extends readonly string[]>(
  values: T
): SingleParserBuilder<T[number]> {
  return parseAsStringLiteral(values);
}

export function createReportGroupParser<const T extends readonly string[]>(
  values: T
): SingleParserBuilder<T[number]> {
  return parseAsStringLiteral(values);
}

export const parseAsReportIdArray = parseAsArrayOf(parseAsString);

export function canonicalizeReportIds(ids: readonly string[]): string[] {
  return [...new Set(ids.map(id => id.trim()).filter(Boolean))].sort();
}
